<div [hidden]="!showloader" class="loader">
  <div class="loader-bg">
    <svg>
      <symbol id="s-text">
        <text x="50%" y="50%" text-anchor="middle">ECHO</text>
      </symbol>

      <g class="g-ants">
        <use xlink:href="#s-text" class="text-copy"></use>
        <use xlink:href="#s-text" class="text-copy"></use>
        <use xlink:href="#s-text" class="text-copy"></use>
        <use xlink:href="#s-text" class="text-copy"></use>
        <use xlink:href="#s-text" class="text-copy"></use>
      </g>
    </svg>
  </div>
</div>